import { helper as buildHelper } from '@ember/component/helper';
import CurrentUserStore from 'mewe/stores/current-user-store';

export default buildHelper(function (value) {
  return value[0] == CurrentUserStore.getState().get('id');
});
